// Replaced by Angular's application builder; never derived from browser storage.
declare const CC_BUILD_ID: string;
export const RUNNING_BUILD_ID = CC_BUILD_ID;
